import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import axios from "axios";
import "./pages/commoncss/pages.scss";

axios.defaults.baseURL = "https://api.dawabajar.com";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
